///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { NgModule } from '@angular/core';

import { systemInfoFeatureKey } from './system-info.state';
import { reducer } from './system-info.reducers';
import { SystemInfoEffects } from './effects/system-info.effects';

@NgModule({
    declarations: [],
    imports: [CommonModule, StoreModule.forFeature(systemInfoFeatureKey, reducer), EffectsModule.forFeature([SystemInfoEffects])],
    providers: []
})
export class SharedSystemInfoStoreModule {}
